import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => {
  return {
    mainSliderBlock: {
      '& .slick-list': {
        borderRadius: 10,
      },
      [theme.breakpoints.up('sm')]: {
        '& .slick-slide>div': {
          padding: '0!important',
        },
      },
    },
    baseSlide: {
      // maxWidth: 1242,
      maxWidth: '100%',
      height: 492,
      borderRadius: 10,

      '& .MuiTypography-root': {
        whiteSpace: 'break-spaces',
      },

      [theme.breakpoints.up('sm')]: {
        height: 560,
      },
    },
    headingBox: {
      padding: '12px 0',
      borderBottom: '1px solid #E0E0E0',

      '& .MuiTypography-root': {
        fontWeight: 600,
        fontSize: '1.8rem',
        lineHeight: '2.4rem',
      },
      [theme.breakpoints.up('sm')]: {
        borderBottom: 'none',

        '& .MuiTypography-root': {
          fontSize: '2.8rem',
          lineHeight: '3.6rem',
        },
      },
    },
  };
});
